// @flow
import React from 'react';
import {connect} from 'react-redux';
// import classNames from 'classnames';
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import {Widget} from 'app/components/Widget';
import {Image} from 'app/components/Image';
import styles from './AdsBox.styles.js';

class AdsBox extends React.Component<Props> {

  render() {
    const {position, classes} = this.props;
    let index = 0;

    return(
      <Grid container spacing={0}>
        {this.props.list && this.props.list.map(item => {

          // Sizes definitions
          let hiddenSizes = [];
          if(!item.s_width)
            hiddenSizes = ['sm', 'xs'];
          if(!item.m_width)
            hiddenSizes = [...hiddenSizes, 'md'];
          if(!item.l_width)
            hiddenSizes = [...hiddenSizes, 'lg'];
          //

          if (Number(item.position) !== Number(position))
            return '';

          let spcing;
          if (index++ === 0) {
            spcing = 16;
          }
          return (
            <Hidden key={item.image} only={[...hiddenSizes]}>
              <Grid
                item
                xs={item.x_width || 12}
                sm={item.s_width}
                md={item.m_width}
                lg={item.l_width}
                className={classes.itemWrapper}
              >
                <Widget className={{container: classes.widgetContainer}} spacing={spcing}>
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Image
                      src={item.image}
                      alt={item.alt}
                      className={{root: classes.imageRoot, image: classes.image}}
                    />
                  </a>
                </Widget>
              </Grid>
            </Hidden>
          );
        })}
      </Grid>
    )
  }
}

const mapStateToProps = (state) => ({
  list: state.ads
});

const Component = connect(mapStateToProps)(withStyles(styles)(AdsBox));
export {Component as AdsBox};
export default Component;